const AuthFooter = () => {
    const today = new Date().getFullYear();

    return (
        <div className="authFooter">
            <span className="color-dark-6">
                <a href="/" className="color-dark-6 tt-14 link">
                    Oliver AI
                </a>{" "}
                © {today.toString()}
            </span>

            <div className="ml-auto d-flex gap-32">
                <a className="tt-14 link" target="_blank" href="/termos-de-uso-e-politica-de-privacidade" rel="noopener">
                    Termos de Uso e Política de Privacidade
                </a>
            </div>
        </div>
    );
};

export default AuthFooter;
